import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import uniqueId from 'lodash/uniqueId';

import '../../../node_modules/slick-carousel/slick/slick.scss';
import '../../../node_modules/slick-carousel/slick/slick-theme.scss';
import './LandingReviewsCarousel.scss';

import LandingCarousel from '../LandingCarousel/LandingCarousel';

import Service from './ReviewsCarouselService';

class Review extends React.Component {
    componentWillMount() {
        let reviewId = uniqueId();
        console.log('getLandingReviewIdUniq: ' + reviewId);
        this.readMoreBtnId = 'readMoreBtnLanding_' + reviewId;
        this.reviewTextId = 'reviewTextLanding_' + reviewId;
        this.reviewInfoId = 'reviewInfoLanding_' + reviewId;
        this.readMoreClick = this.readMoreClick.bind(this);
    }

    readMoreClick(e) {
        e.preventDefault();
        console.log('Read more was clicked in landing reviews.');
        let readMoreBtn = document.getElementById(this.readMoreBtnId);
        let reviewText = document.getElementById(this.reviewTextId);
        let reviewInfo = document.getElementById(this.reviewInfoId);

        if (readMoreBtn.textContent === 'Read more ›') {
            reviewText.classList.remove("text");
            reviewText.classList.add("textExpanded");

            reviewInfo.style.display = 'none';
            readMoreBtn.textContent = 'Close ›';
        }
        else {
            reviewText.scrollTop = 0;
            reviewText.classList.remove("textExpanded");
            reviewText.classList.add("text");

            reviewInfo.style.display = 'block';
            readMoreBtn.textContent = 'Read more ›';
        }
    }

    render() {
        let review = this.props.review;
        let maxNumberOfCharacters = 170;
        let readMore;

        if (review.text.length > maxNumberOfCharacters) {
            readMore = <a id={this.readMoreBtnId} href="#" onClick={this.readMoreClick}>Read more &#8250;</a>;
        }
        else {
            readMore = <div />;
        }

        return <div className="review-item">
            <section id={this.reviewTextId} className="text">
                {review.text}
            </section>

            <section className='readMoreSection'>
                {readMore}
            </section>

            <section id={this.reviewInfoId} className="review-info row">
                <div className="col-xs-9 col-sm-9">
                    {review.rating > 0 && <Rating rating={review.rating} />}

                    <div className="reviewer-name">
                        {review.reviewerName}
                    </div>

                    <div className="car-info">
                        {review.carDescription}
                    </div>

                    {review.date && <div className="review-date">
                        {moment(review.date).format('MMMM, YYYY')}
                    </div>
                    }

                    <div className="source">
                        {review.source.name}
                    </div>
                </div>

                <div className="col-xs-3 col-sm-3 text-right">
                    <img src="/images/components/reviews/icon.svg" className="review-icon" alt="icon" />
                </div>
            </section>
        </div>
    }
}

export default class LandingReviewsCarousel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reviews: []
        };
    }

    componentDidMount() {
        Service.getReviews().then((data) => {
            this.setState({
                reviews: data
            });
        });
    }

    render() {
        let reviews = this.state.reviews.map((review, index) => {
            return (<div key={index}>
                <Review review={review} />
            </div>);
        });

        if (reviews.length > 0) {
            return (<LandingCarousel columnsAmount={this.props.columnsAmount} isSlick={this.state.reviews.length > 1}>
                {reviews}
            </LandingCarousel>);
        }
        else {
            return (<div></div>);
        }
    }
}

LandingReviewsCarousel.propTypes = {
    columnsAmount: PropTypes.number.isRequired
};

let Rating = ({ rating }) => {
    let ratingItems = [];

    for (let i = 0; i < 5; i++) {
        let itemImage = i < rating ? "/images/components/reviews/star-filled.svg" : "/images/components/reviews/star-empty.svg";

        let ratingItem = (
            <li className="rating-item" key={i}>
                <img src={itemImage} alt="Alternate Text" />
            </li>);
        ratingItems.push(ratingItem);
    }

    return (
        <ul className="rating">
            {ratingItems}
        </ul>
    );
};


let DOMcontainers = [...document.getElementsByClassName('js-landing-review')];

DOMcontainers.forEach((container) => {
    let columnsAmount = +container.dataset.columnsAmount;

    ReactDOM.render(<LandingReviewsCarousel columnsAmount={columnsAmount} />,
        container);
});


// WEBPACK FOOTER //
// ./Src/LandingPage/LandingReviewsCarousel/LandingReviewsCarousel.jsx